export default "data:image/jpeg;base64,Tm90IEZvdW5k"